export default {"src":"/_next/static/media/shima.534ef1b6.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};